module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-04@2x.73dccf54.jpg";